var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.25H14.6283C15.6229 2.25 16.5767 2.64509 17.28 3.34835L19.6516 5.72002C20.3549 6.42328 20.75 7.37711 20.75 8.37167V18C20.75 20.0711 19.0711 21.75 17 21.75H7C4.92893 21.75 3.25 20.0711 3.25 18V6C3.25 3.92893 4.92893 2.25 7 2.25ZM14.6283 3.75H7C5.75736 3.75 4.75 4.75736 4.75 6V18C4.75 19.2426 5.75736 20.25 7 20.25H17C18.2426 20.25 19.25 19.2426 19.25 18V8.37167C19.25 7.77493 19.0129 7.20264 18.591 6.78068L16.2193 4.40901C15.7974 3.98705 15.2251 3.75 14.6283 3.75Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.25C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.3797 16.4678 17.6935 16.1018 17.7432L16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.6203 7.53215 16.3065 7.89823 16.2568L8 16.25H16Z",
    fill: "#B0B7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.75C16.4142 12.75 16.75 13.0858 16.75 13.5C16.75 13.8797 16.4678 14.1935 16.1018 14.2432L16 14.25H8C7.58579 14.25 7.25 13.9142 7.25 13.5C7.25 13.1203 7.53215 12.8065 7.89823 12.7568L8 12.75H16Z",
    fill: "#B0B7C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.25C11.4142 9.25 11.75 9.58579 11.75 10C11.75 10.3797 11.4678 10.6935 11.1018 10.7432L11 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10C7.25 9.6203 7.53215 9.30651 7.89823 9.25685L8 9.25H11Z",
    fill: "#B0B7C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.25C14.8797 2.25 15.1935 2.53215 15.2432 2.89823L15.25 3V6.5C15.25 7.14721 15.7419 7.67953 16.3722 7.74355L16.5 7.75H20C20.4142 7.75 20.75 8.08579 20.75 8.5C20.75 8.8797 20.4678 9.19349 20.1018 9.24315L20 9.25H16.5C15.0375 9.25 13.8416 8.1083 13.755 6.66752L13.75 6.5V3C13.75 2.58579 14.0858 2.25 14.5 2.25Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarReports);
export default __webpack_public_path__ + "static/media/side-bar-reports.c074019715e58c2474e60833a104e9df.svg";
export { ForwardRef as ReactComponent };